var app = angular.module("nms.dynamicDevice");

app.directive("string",
    function() {
        return {
            restrict: "E",
            templateUrl: "templates/features/dynamic-device/domain/yang/leaf/types/string.html"
        };
    }
);
